import domLoaded from 'dom-loaded';
import up from '@/lib/unpoly';

// Watch form checkboxes to handle the special checkbox logic and then
// auto-submit.
up.compiler('.search-form input[type=checkbox]', function(element) {
  up.watch(element, function(value, name, { origin }) {
    if (origin.id === "tags_propane") {
      document.querySelectorAll('#tags_renewable-propane').forEach((el) => {
        el.checked = origin.checked
      });
    }

    if (origin.id === "tags_natural-gas") {
      document.querySelectorAll('#tags_compressed-natural-gas, #tags_liquified-natural-gas, #tags_renewable-natural-gas').forEach((el) => {
        el.checked = origin.checked
      });
    }

    return up.submit(element);
  });
});

// Scroll to the filters section if the URL contains a 'type' parameter.
domLoaded.then(() => {
  const urlParams = new URLSearchParams(window.location.search);

  if (urlParams.has('type') || urlParams.has('keyword')) {
    const filtersSection = document.querySelector('#cs-pubs-search-banner');

    if (filtersSection) {
      filtersSection.scrollIntoView({ behavior: 'smooth' });
    }
  }
});
